<template>
    <div :style="{color: fontColor}" class="base-title" :title="title" :class="`base-title-${borderType}`">
        {{title}}
    </div>
</template>

<script>
    export default {
        name: 'base-title',
        props: {
            title: {
                type: String,
                default: ''
            },
            borderType: {
                type: [String, Number],
                default: 0
            },
            fontColor: {
                type: String,
                default: '#000'
            }
        },
        mounted() {
        },
        methods: {
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped lang="scss">
    @import 'src/sass/index.scss';
    .base-title{
        padding: 25px 5px 25px 5px;
        color: black;
        font-size: 14px;
        font-weight: bold;
        &.base-title-1{
            border-top: 1px solid #ddd;
            margin-top: 20px;
        }
        &.base-title-2{
            border-bottom: 1px solid #ddd;
            margin-bottom: 20px;
        }
    }
</style>
